































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VueEvent from "../../core/decorator/VueEvent";
import { markdown } from "../../core/markdown/markdown";
import OtherTextSpanComponent from "@/app/basic/other-text/OtherTextSpanComponent.vue";

@Component({
  components: { OtherTextSpanComponent }
})
export default class OtherTextComponent extends Vue {
  @Prop({ type: String, required: true })
  private value!: string;

  private json: any[] = [];
  private readonly checkRegExp: RegExp = new RegExp(
    "\\[[ x]](\\([^\\r\\n]*\\))?",
    "g"
  );
  private readonly selectRegExp: RegExp = new RegExp(
    "(\\[[^\\r\\n]+])\\([^\\r\\n]*\\)",
    "g"
  );

  public input(value: string) {
    this.$emit("input", value);
  }

  private get localValue(): string {
    return this.value;
  }

  private set localValue(value: string) {
    this.input(value);
  }

  @Watch("localValue", { immediate: true })
  private onChangeRawText() {
    this.json = markdown(this.localValue);
  }

  @VueEvent
  private onChangeCheck(index: number, value: boolean) {
    this.localValue = this.localValue.replace(this.checkRegExp, (m, p1) => {
      if (p1) return m;
      return index-- ? m : `[${value ? "x" : " "}]`;
    });
  }

  @VueEvent
  private onChangeSelect(index: number, value: string) {
    this.localValue = this.localValue.replace(this.selectRegExp, (m, p1) => {
      return index-- ? m : `${p1}(${value})`;
    });
  }
}
